import { useMemo } from 'react';

// @ts-expect-error module is untyped
import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import * as ThemeQueryField from 'marketplace-ui-assets-core/constants/ThemeQueryField';
// @ts-expect-error module is untyped
import { getAssetPageFeatureI18nKey } from 'ecosystem-marketplace-core/utils/i18n';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { getIsPrerenderUserAgent } from 'marketplace-ui-common/utils/userAgent';
import { deployed } from '../../../utils/env';
import { getFullPublicThemesUrl } from '../../../utils/urls';
import { useUsedPageFeatureValues } from '../../../hooks/useUsedPageFeatureTypeValues';
import AssetPageFeatureUrls from '../../../constants/urls/AssetPageFeature';
import FilterSideNav from './FilterSideNav';
import { jsx as _jsx } from "react/jsx-runtime";
function usePageFeatureOptions() {
  const pageFeatureValues = useUsedPageFeatureValues();
  const options = useMemo(() => {
    return pageFeatureValues.map(value => ({
      text: unescapedText(getAssetPageFeatureI18nKey(value)),
      value: value
    })).sort((a, b) => localeComparator(a.text, b.text));
  }, [pageFeatureValues]);
  return options;
}

// type guard for safely accessing AssetPageFeatureUrls object
function isPageFeatureUrlValue(value) {
  return value in AssetPageFeatureUrls;
}
function usePageFeatureNavOptions() {
  const options = usePageFeatureOptions();
  const isDeployed = deployed();
  return options.reduce((navOptions, option) => {
    const {
      value: optionValue
    } = option;
    if (isPageFeatureUrlValue(optionValue)) {
      const url = AssetPageFeatureUrls[optionValue];
      navOptions.push(Object.assign({}, option, {
        href: `${getFullPublicThemesUrl('en', !isDeployed)}/${url}`
      }));
    }
    return navOptions;
  }, []);
}
function PageFeatureNav({
  value
}) {
  const options = usePageFeatureNavOptions();
  const activeValue = value.length === 1 ? value[0] : null;
  return /*#__PURE__*/_jsx(FilterSideNav, {
    "aria-label": unescapedText('marketplace-assets-ui.assets.filters.pageFeatures.title'),
    name: ThemeQueryField.PAGE_FEATURES,
    options: options,
    value: activeValue
  });
}
const PageFeatureFilter = ({
  disabled,
  onChange,
  scrollable = true,
  value
}) => {
  const isPrerender = getIsPrerenderUserAgent();
  const options = usePageFeatureOptions();
  return isPrerender ? /*#__PURE__*/_jsx(PageFeatureNav, {
    value: value
  }) : /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.pageFeatures.title'),
    disabled: disabled,
    multi: true,
    name: ThemeQueryField.PAGE_FEATURES,
    onChange: onChange,
    options: options,
    scrollable: scrollable,
    value: value
  });
};
export default PageFeatureFilter;